import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

import WarningIcon from '@mui/icons-material/Warning';

import completeIcon from '../../assets/complete_tick_icon.svg';

import { caseConstants } from '../../constants';

import './day-info.scss';

const DayInfoMobile = ({ selectedDay, cases, goToCase }) => {
  const renderIcon = (item) => {
    const access = item.access;
    const complete = item.step > caseConstants.numberOfSteps;
    const rejected = item.status === caseConstants.statuses.rejected;

    if (rejected) {
      return <WarningIcon color={access ? 'primary' : 'secondary'} />;
    }
    if (complete) {
      return <img src={completeIcon} alt="complete-icon" width={15} />;
    }
    return <div className={`indicator ${access ? 'active' : ''}`} />;
  };

  return (
    <div className="day-info-mobile-container">
      <h4>{format(selectedDay, 'PPP')}</h4>
      {!cases.length ? (
        <div className="empty-day">No assigned cases this day</div>
      ) : (
        <div className="cases-list">
          {cases.map((item) => (
            <div key={item.id} className="case-item" onClick={() => goToCase(item.id)}>
              <div className="d-flex space-between">
                <div className="d-flex">
                  <div className="case-indicator">{renderIcon(item)}</div>
                  <div className="pointer">{item.formattedId || item.id}</div>
                </div>
              </div>
              <div className="d-flex space-between">
                <div>{item.hospital}</div>
                <div>{item.procedureName}</div>
              </div>
              <div className="d-flex space-between">
                <div className={`m-r-md flex-1 ${item.access ? 'primary' : 'secondary'}`}>
                  {caseConstants.caseActions[item.step] || ''}
                </div>
                <div className="d-flex flex-end">
                  <span className="primary">
                    {item.step > caseConstants.numberOfSteps
                      ? caseConstants.numberOfSteps
                      : item.step}
                  </span>
                  /{caseConstants.numberOfSteps}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

DayInfoMobile.propTypes = {
  selectedDay: PropTypes.instanceOf(Date),
  dayCases: PropTypes.array,
  goToCase: PropTypes.func,
};

export default memo(DayInfoMobile);
